export default __webpack_public_path__ + "static/startup-refer-62767de1ae792e72ad869b886aee04a1.png";